import { BrowserRouter, Routes, Route } from "react-router-dom";
import Menu from "./main";
import MainPage from "./MainPage";
import Photos from "./Photos";
import { useRef } from "react";

function App() {
    // Create refs for the sections in MainPage
    const aboutRef = useRef(null);
    const missionRef = useRef(null);
    const joinRef = useRef(null);

    // Scroll functions
    const scrollToAbout = () => {
        if (aboutRef.current) {
            aboutRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const scrollToMission = () => {
        if (missionRef.current) {
            missionRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const scrollToJoin = () => {
        if (joinRef.current) {
            joinRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <BrowserRouter basename="/">
            <Routes>
                <Route path="/" element={<Menu onScrollToAbout={scrollToAbout} onScrollToMission={scrollToMission}  onScrollToJoin={scrollToJoin}/>}>
                    {/* Pass scroll functions as props */}
                    <Route index element={<MainPage aboutRef={aboutRef} missionRef={missionRef}  joinRef={joinRef}/>} />
                    <Route path="/gallery" element={<Photos />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
